import React from 'react';
import { bool, string, func, number } from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import { withRtl } from '../hoc';

import CheckIcon from '../icons/Check';
import CloseIcon from '../icons/Close';
import style from './StatusCard.scss';
import localMessages from './localMessages';
import {customisedIntlFormatMessage} from '../../utils/helpers';
import messages from '../../locale/messages';

const StatusCard = ({
  offerStatus='',
  statusOnClick=() => {},
  headerTitle,
  infoCard=false,
  subheaderTitle,
  programId=0,
  waitlistId=0,
  deadlineDate=null,
  schoolId=0,
  intl,
  disabled=false,
  isSHSDiscoveryOffer=false,
  supplimentalLinkText=null,
  isSR=false,
  showSRQuestionsPopUp=() => {},
  isRejectAcceptedOfferAllowed=false,
  declinedNotetext,
  canAddProgramToWaitlist,
  canAddRemoveWaitlist,
  onRejoinWaitlist,
  offer,
}) => {
  const rootClass = classNames(
    style.root,
    { [style.rootDisabled]: offerStatus !== 'AC' && infoCard },
    { [style.rootInfoCard]: infoCard },
  );
  const responses = [
    { response: 'AC', label: customisedIntlFormatMessage(intl, localMessages.offerResponseAccepted) },
    { response: 'DE', label: customisedIntlFormatMessage(intl, localMessages.offerResponseDeclined) },
    { response: 'OO', label: 'Opt Out' },
    { response: 'NR', label: 'No Response' },
  ];
  const statusText = responses.find(({ response }) => response === offerStatus);

  const showSRFilledPopUp = () => {
    showSRQuestionsPopUp(waitlistId, programId, true)
  }

  const formatStartDate = (value, locale) => {
    if (!value) return null;
    const containsDigit = /\d/.test(value);

    if (!containsDigit) {
      return value;
    }

    return new Date(value).toLocaleDateString(intl.locale, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC',
    });
};

  return (
    <div className={rootClass}>
      {infoCard ? (
        <>
          <div>
            <h4>{headerTitle}</h4>
            <h6 className={style.cardSubheader}>{subheaderTitle}</h6>
            {offer.two_k_start_date && (
              <h6 className={style.cardSubheader}>
                {customisedIntlFormatMessage(intl, localMessages.waitlistStatusCardStartDateText)}:
                <b>
                  {formatStartDate(offer.two_k_start_date)}
                </b>
              </h6>
            )}
            {
              offerStatus === 'AC' && isSR && (
                <button
                  type="button"
                  onClick={showSRFilledPopUp}
                  className={style.supplimentalLink}
                >
                  {supplimentalLinkText}
                </button>
              )
            }
          </div>
          <div className={style.cardStatus}>
            {/* Making sure this doesn't break if it can't recognize the offerStatus: */}
            {!isSHSDiscoveryOffer && (
              <>
              {offerStatus === 'AC' ? <CheckIcon size={18} fill="#fff" /> : <CloseIcon size={18} fill="#fff" />}
              </>
            )}
            <h6>
              {customisedIntlFormatMessage(intl, localMessages.waitlistStatusCardStatusText)}
              {isSHSDiscoveryOffer ? (
                <>
                <br /> 'Pending completion of summer Discovery program'
                </>
              ):(
                <>
                <br /> {statusText ? statusText.label : ''}
                </>
              )}
            </h6>
            {!offer.is_shs_offer && !offer.is_lga_offer && offerStatus !== 'AC' && offerStatus !== 'OO' && canAddProgramToWaitlist && canAddRemoveWaitlist && (
              <h6 className={style.joinWaitlistContainer}>
                <button
                  type="button"
                  onClick={disabled || offer.processingRejoin ? () => {} : () => onRejoinWaitlist(programId, schoolId, offer)}
                  className={style.joinWaitlistLink}
                  disabled={offer.processingRejoin}
                >
                  {intl.formatMessage(messages.generalStringAddWaitlist)}
                </button>
              </h6>
            )}
            {
              offerStatus === 'AC' && isRejectAcceptedOfferAllowed && <div className={style.buttonContainer}>
                <button
                  onClick={disabled ? (() => {}) : (() => statusOnClick(headerTitle, subheaderTitle, programId, waitlistId, false, ''))}
                  disabled={disabled}
                  className={style.secondaryDeclineButton}
                >
                  {customisedIntlFormatMessage(intl, localMessages.waitlistStatusCardDeclineText)}
                </button>
              </div>
            }
          </div>
        </>
      ) : (
        <>
          <h4>{headerTitle}</h4>
          <h6 className={style.cardSubheader}>{subheaderTitle}</h6>
          {offer.two_k_start_date && (
            <div className={style.response}>
              {customisedIntlFormatMessage(intl, localMessages.waitlistStatusCardStartDateText)}:{' '}
              <b>
                {formatStartDate(offer.two_k_start_date)}
              </b>
            </div>
          )}
          <div className={style.buttonContainer}>
            <button
              onClick={disabled ? (() => {}) : (() => statusOnClick(headerTitle, subheaderTitle, programId, waitlistId, true, offer.two_k_accept_information_message))}
              disabled={disabled}
            >
              {customisedIntlFormatMessage(intl, localMessages.waitlistStatusCardAcceptText)}
            </button>
            <button
              onClick={disabled ? (() => {}) : (() => statusOnClick(headerTitle, subheaderTitle, programId, waitlistId, false, ''))}
              disabled={disabled}
            >
              {customisedIntlFormatMessage(intl, localMessages.waitlistStatusCardDeclineText)}
            </button>
          </div>
          {deadlineDate && !infoCard && (
            <div className={style.response}>
              Response Deadline:{' '}
              <b>
                {new Date(deadlineDate).toLocaleDateString(intl.locale, {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                  timeZone: 'UTC',
                })}
              </b>
            </div>
          )}
        </>
      )}
    </div>
  );
};

StatusCard.propTypes = {
  offerStatus: string,
  headerTitle: string.isRequired,
  infoCard: bool,
  subheaderTitle: string.isRequired,
  statusOnClick: func,
  programId: number,
  waitlistId: number,
  schoolId: number,
  deadlineDate: string,
  disabled: bool,
  isSHSDiscoveryOffer: bool,
  supplimentalLinkText:string,
  isSR: bool,
  showSRQuestionsPopUp: func,
  isRejectAcceptedOfferAllowed: bool,
  canAddProgramToWaitlist: bool,
  canAddRemoveWaitlist: bool,
  onRejoinWaitlist: func,
};

StatusCard.defaultProps = {
  offerStatus: '',
  infoCard: false,
  statusOnClick: () => {},
  programId: 0,
  waitlistId: 0,
  schoolId:0,
  deadlineDate: null,
  disabled: false,
  isSHSDiscoveryOffer: false,
  supplimentalLinkText:null,
  isSR: false,
  showSRQuestionsPopUp: () => {}, 
  isRejectAcceptedOfferAllowed: false,
  canAddProgramToWaitlist: false,
  canAddRemoveWaitlist: false,
  onRejoinWaitlist: () => {},
};

export { StatusCard };
export default withRtl(style)(withStyles(style)(injectIntl(StatusCard)));
